module.exports = __webpack_public_path__ + "img/photo-portafolio.e2cfd060.jpg";